import { mobileBurger } from '../components/header/header'
import { emodji } from '../components/pages/about/about'
import { map } from '../components/pages/contacts/contacts'
import { form, openPopup } from '../components/mixins/popup/popup'
import { ord } from '../components/mixins/ord/ord'

window.addEventListener('DOMContentLoaded', () => {
  mobileBurger()
  emodji()
  map()
  form()
  openPopup()
  ord()
})
